<template>
  <TarjetaDatos titulo="Contrato">
    <Campo2L :valor="poliza.periodicidad" etiqueta="Periodicidad" />
    <Campo2L
      :valor="poliza.fecAntiguedad | dateDDMMYYYY"
      etiqueta="Antigüedad"
    />
    <Campo2L :valor="poliza.fecProximoRecibo" etiqueta="Fecha Próximo Recibo" />
    <Campo2L :valor="poliza.producto" etiqueta="Producto" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
